// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2krJt","left":"StickyBox_left__27YBV","right":"StickyBox_right__22RGy"};